import React from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import './index.scss';

const LoadingError = ({ canReload = true }) => {
  const { t } = useTranslation();
  return (
    <section className="loading-error" data-testid="loading-error">
      <div>
        <Icon className="fill icon-orange" width="64" name="search-error" />
      </div>
      <div>
        <h1>{t('po.topics.errorLoading')}</h1>
      </div>
      <div>
        <h2>
          {t('po.topics.unableToLoad')}
          {canReload && (
            <div className="refresh-message">{t('po.topics.refresh')}</div>
          )}
        </h2>
      </div>
      {canReload && (
        <div>
          <button
            className="ui-button"
            type="button"
            onClick={() => window.location.reload()}
          >
            {t('po.topics.reload')}
          </button>
        </div>
      )}
    </section>
  );
};

export default LoadingError;
